const Types = {    
    SEARCH_REQUEST: '@protocolo-excluir/SEARCH_REQUEST', 
    SEARCH_SUCCESS: '@protocolo-excluir/SEARCH_SUCCESS', 
    SEARCH_FAILURE: '@protocolo-excluir/SEARCH_FAILURE',

    SELECT: '@protocolo-excluir/SELECT',
    SELECT_MULTI: '@protocolo-excluir/SELECT_MULTI',
    SEARCH_REASON_SUCCESS: '@protocolo-excluir/SEARCH_REASON_SUCCESS',
    SEARCH_REASON_REQUEST: '@protocolo-excluir/SEARCH_REASON_REQUEST', 
    SEARCH_REASON_FAILURE: '@protocolo-excluir/SEARCH_REASON_FAILURE',
    DELETE_REQUEST: '@protocolo-excluir/DELETE_REQUEST',  
    DELETE_FAILURE: '@protocolo-excluir/DELETE_FAILURE',
    DELETE_PROTOCOL_REQUEST: '@protocolo-excluir/DELETE_PROTOCOL_REQUEST',  
    DELETE_PROTOCOL_FAILURE: '@protocolo-excluir/DELETE_PROTOCOL_FAILURE',
    CONFIRMAR_EXCLUSAO_CONTRATO: '@protocolo-excluir/CONFIRMAR_EXCLUSAO_CONTRATO',
    CONFIRMAR_EXCLUSAO_PROTOCOLO: '@protocolo-excluir/CONFIRMAR_EXCLUSAO_PROTOCOLO',
    CLEAR_STATUS: '@protocolo-excluir/CLEAR_STATUS',
    REMOVER_CONTRATO_DO_PROTOCOLO: '@protocolo-excluir/REMOVER_CONTRATO_DO_PROTOCOLO',
};

export default Types;